export default __webpack_public_path__ + "static/feature_01-56f7f1cf96ba7950d91edf3b2c7b0d5a.png";